import CustomList from '../Util/List/CustomList/CustomList';
import CustomListContainer from '../Util/List/CustomList/CustomListContainer';
import config from '../../../../application/config/config';
import { getUserSession } from '../../../util/core/Session';

function List() {
    const session = getUserSession();

    const pathFrontEnd = '/core/applicationsprofiles/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpoint: config.endpoints.backend + 'core/applicationsprofiles/getall',
        endpointDelete: `${config.endpoints.backend}core/applicationsprofiles/delete`
    }

    let list = {
        labelTitle: 'Lista de Perfis de acesso',
        labelTitleButtonAdd: 'Incluir novo perfil',
        fieldsShowOnDelete: ['application_name', 'profile_name'],
        showPrintButtons: false,
        filter: {
            core_application_instance_id: session.user.application_instance_id,
        },
        columns: [
            {
                name: 'application_name',
                label: 'Aplicação'
            },
            {
                name: 'profile_name',
                label: 'Perfil'
            }
        ],
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={list} />}
            />
        </div>
    );
}
export default List;
